import attributes from "../../../Constants/js/attributes";

const NotificationPopupItemHandler = (function(){

    function clear(){
        let ul = document.querySelector('.notification-popup ul');
        ul.innerHTML = '';
    }

    function render(item) {
        let ul = document.querySelector('.notification-popup ul');
        if(!ul) throw new Error('List container is missing');

        const active = 'notification-popup__item--active';

        let li = document.createElement('li');
        li.setAttribute('data-id', item.id);
        li.classList.add('notification-popup__item');

        if (item.active) {
            li.classList.add(active);
        }

        // Coupe Link
        let a = document.createElement('a');
        a.setAttribute('href', item.link);

        let spanText = document.createElement('span');
        spanText.innerText = item.text;

        a.appendChild(spanText);

        // Description / Text
        let spanDate = document.createElement('span');
        spanDate.innerText = `${item.description} ${item.date}`;

        // Notification Type Icon
        if (item.typeIconCss) {
            let typeIcon = document.createElement('i');
            typeIcon.setAttribute('class', item.typeIconCss);

            if (item.typeIconTitle) {
                typeIcon.setAttribute('title', item.typeIconTitle);
                typeIcon.setAttribute('alt', item.typeIconTitle);
            }
            
            li.appendChild(typeIcon);
        }

        // Content Container
        let container = document.createElement('div');
        container.classList.add('description');
        container.appendChild(a);
        container.appendChild(spanDate);

        li.appendChild(container);

        // Read/unread icon
        if(item.statusIconCss) {
            let activeIcon = document.createElement('i');
            activeIcon.setAttribute('class', item.statusIconCss);

            if (item.active) {
                activeIcon.setAttribute('tabindex', '0');
            }

            if (item.statusIconTitle) {
                activeIcon.setAttribute('title', item.statusIconTitle);
                activeIcon.setAttribute('alt', item.statusIconTitle);
            }
            
            li.appendChild(activeIcon);
        }
        
        li.addEventListener(attributes.events.click, e => {
            if(!this._itemChangedEventListeners) {
                return;
            }

            this._itemChangedEventListeners.forEach(handler => {
                handler(item, li);
            });
        });

        ul.appendChild(li);
    }

    function addItemChangedEventListener(handler){
        if(!this._itemChangedEventListeners) {
            this._itemChangedEventListeners = [];
        }

        this._itemChangedEventListeners.push(handler);
    }

    return {
        render: render,
        clear: clear,
        addItemChangedEventListener: addItemChangedEventListener
    };

})();

export default NotificationPopupItemHandler;